import { render, staticRenderFns } from "./GhostwritingClient.vue?vue&type=template&id=d6b01a68&scoped=true&"
import script from "./GhostwritingClient.vue?vue&type=script&lang=js&"
export * from "./GhostwritingClient.vue?vue&type=script&lang=js&"
import style0 from "./GhostwritingClient.vue?vue&type=style&index=0&id=d6b01a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b01a68",
  null
  
)

export default component.exports